
import { getBlockResponseFromError } from '@/utils/blockUser'

const DEFAULT_AVATAR = require('@/assets/image/global/default-avatar.png')

export default {
  name: 'UnblockUserDialog',
  data() {
    return {
      innerVisible: false,
      isSubmitting: false, // 确认移出提交中，防止重复点击
      dialogWidth: '480px',
      nickname: '',
      avatar: '',
      targetUserId: null,
      pending: null, // Promise 回调，仅 open() 打开时有值
    }
  },
  computed: {
    avatarSrc() {
      return this.avatar || DEFAULT_AVATAR
    },
    /** 空昵称按已注销用户展示 */
    displayNickname() {
      const name = this.nickname
      if (name === undefined || name === null || String(name).trim() === '') {
        return this.$t('page.DELETED_USER')
      }
      return name
    },
  },
  mounted() {
    this.updateDialogWidth()
    if (process.client) {
      window.addEventListener('resize', this.updateDialogWidth)
    }
  },
  beforeDestroy() {
    if (process.client) {
      window.removeEventListener('resize', this.updateDialogWidth)
    }
  },
  methods: {
    /**
     * 打开移出黑名单确认。成功 resolve，取消/关闭 reject('cancel')。
     * @param {{ target_user_id: number|string, nickname?: string, avatar?: string }} options
     */
    open(options = {}) {
      if (this.pending) {
        this.settle(false)
      }
      this.nickname = options.nickname || ''
      this.avatar = options.avatar || ''
      this.targetUserId = options.target_user_id
      this.updateDialogWidth()
      this.innerVisible = true
      return new Promise((resolve, reject) => {
        this.pending = { resolve, reject }
      })
    },
    /** 关闭并按是否确认结束 Promise；失败提交不走这里 */
    settle(confirmed) {
      const pending = this.pending
      this.pending = null
      this.innerVisible = false
      if (!pending) return
      if (confirmed) {
        pending.resolve(true)
        return
      }
      pending.reject('cancel')
    },
    /** 弹窗宽度：移动端 90%，桌面固定 480px 对齐设计稿 */
    updateDialogWidth() {
      if (!process.client) return
      this.dialogWidth = document.body.clientWidth <= 768 ? '90%' : '480px'
    },
    onAvatarError(e) {
      e.target.src = DEFAULT_AVATAR
    },
    /** 取消或关闭不改变黑名单状态；未显示时忽略 close */
    handleCancel() {
      if (this.isSubmitting || !this.innerVisible) return
      this.settle(false)
    },
    /** 提交移出。失败保留弹窗，提示只认接口 msg；幂等成功也关窗 */
    async handleConfirm() {
      if (this.isSubmitting) return
      if (!this.$store.state.isLogin) {
        this.$jumpTerminus(1)
        return
      }
      if (!this.targetUserId) return

      this.isSubmitting = true
      try {
        const res = await this.$global.userBlockCancel({
          target_user_id: Number(this.targetUserId),
        })
        this.applyUnblockResult(res)
      } catch (error) {
        const body = getBlockResponseFromError(error)
        if (body) {
          this.applyUnblockResult(body)
        } else {
          this.$message.error(this.$t('page.UNKNOWN_ERROR'))
        }
      } finally {
        this.isSubmitting = false
      }
    },
    /** 成功关弹窗并提示接口 msg；失败保留弹窗，直接展示接口 msg */
    applyUnblockResult(res) {
      if (res && res.code === 200) {
        if (res.msg) {
          this.$message.success(res.msg)
        }
        this.settle(true)
        return
      }
      const isNotLoggedIn = res && res.code === 400 && !res.msg
      if (isNotLoggedIn) {
        this.$message.warning(this.$t('page.PLEASE_SIGN_IN'))
        this.$jumpTerminus(1)
        return
      }
      this.$message.error((res && res.msg) || this.$t('page.UNKNOWN_ERROR'))
    },
  },
}
